<app-blog-header></app-blog-header>
<!--content start-->
<section class="blog-banner">
  <article>
    <div class="container mt-5 headreProcress">
      <div class="row">
        <div class="col-md-12">
          <h1 class="mb-2" style="line-height: 100%">
            {{ currentArticle.article_header }}
          </h1>
          <h6 class="lineh-100">{{ currentArticle.article_sub_header }}</h6>
          <!-- <br/> -->
          <h6 class="pink mb-0">by Honest Gorilla</h6>
          <p></p>
        </div>
        <div class="col-md-11 offset-md-1 d-flex flex-wrap">
          <img
            src="{{ currentArticle.article_img }}"
            alt="{{ currentArticle.article_description }}"
            title="{{ currentArticle.article_title }}"
            style="width: 600px; height: 350px !important"
            class="img-responsive mx-auto d-block mt-3 shadow p-2 mb-3 bg-white"
            alt=""
          />
          <div style="float: left">
            <div class="d-flex h-100">
              <div
                class="social-media-container justify-content-center align-self-center"
              >
                <p class="text-center">Share</p>
                <div class="social-media-icon">
                  <a href="{{ twitterShare }}" target="_blank"
                    ><i class="fa fa-twitter" aria-hidden="true"></i
                  ></a>
                </div>
                <div class="social-media-icon">
                  <a href="{{ fbShare }}" target="_blank"
                    ><i class="fa fa-facebook-official" aria-hidden="true"></i
                  ></a>
                </div>
                <div class="social-media-icon">
                  <a
                    href="https://www.instagram.com/honestgorilla_energy/ "
                    target="_blank"
                    ><img
                      src="assets/images/instagram-icon.png"
                      alt="instagram"
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-12 para"
          *ngIf="currentArticle.article_paragraphs.length > 0"
        >
          <div *ngFor="let para of currentArticle.article_paragraphs">
            <p>{{ para.content }}</p>
            <img
              style="width: 600px; height: 350px !important"
              *ngIf="para.image !== ''"
              class="img-responsive mx-auto d-block mt-3 shadow p-2 mb-3 bg-white"
              alt=""
              src="{{ para.image }}"
            />
          </div>
        </div>
        <div *ngIf="currentArticle.article_sections.length > 0">
          <div
            class="col-md-12 para"
            *ngFor="
              let section of currentArticle.article_sections;
              let i = index
            "
          >
            <h3 class="mb-0">{{ i + 1 }}. {{ section.section_header }}</h3>
            <img
              *ngIf="section.section_img !== ''"
              src="{{ section.section_img }}"
              style="width: 600px; height: 350px !important"
              class="img-responsive mx-auto d-block mt-3 shadow p-2 mb-3 bg-white"
              alt=""
            />
            <div [innerHTML]="section.section_content | keepHtml"></div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="tags-group mb-4">
            <p
              class="tags"
              *ngFor="let tag of currentArticle.tags"
              (click)="showSerched(tag)"
            >
              {{ tag }}
            </p>
          </div>
          <div class="d-flex flex-wrap mb-5 text-center">
            <div class="social-media-icon2 shadow mr-2">
              <a href="{{ fbShare }}" target="_blank"
                ><i class="fa fa-facebook-official" aria-hidden="true"></i>
                Facebook</a
              >
            </div>
            <div class="social-media-icon2 shadow mr-2">
              <a
                href="https://www.instagram.com/honestgorilla_energy/ "
                target="_blank"
                ><img src="assets/images/instagram-icon.png" alt="instagram" />
                Instagram</a
              >
            </div>
            <div class="social-media-icon2 shadow mr-2">
              <a href="{{ twitterShare }}" target="_blank"
                ><i class="fa fa-twitter" aria-hidden="true"></i> Twitter</a
              >
            </div>
          </div>
          <div class="subscribe-container my-5">
            <div class="col-md-6 offset-md-3 text-center">
              <form
                name="form"
                (ngSubmit)="createAccount($event, f, f.form.valid)"
                #f="ngForm"
                novalidate
              >
                <div class="form-group input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="EMAIL ADDRESS"
                    aria-label="Email Address"
                    aria-describedby="button-addon"
                    style="
                      font-size: 16px;
                      font-family: 'Calibre-Bold';
                      color: #555555 !important;
                      height: 36px !important;
                    "
                    name="email"
                    [(ngModel)]="userObj.emailId"
                    #email="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
                    required
                    email
                    pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
                  />
                  <div class="form-group input-group-append">
                    <button class="btn btn-primary" id="button-addon">
                      SUBSCRIBE
                    </button>
                  </div>
                  <div class="invalid-feedback posabs">
                    <div
                      class="boxcolour"
                      *ngIf="
                        f.submitted &&
                        email.invalid &&
                        email.errors &&
                        email.errors.required
                      "
                    >
                      <span
                        _ngcontent-c8=""
                        class="fa fa-exclamation-circle mr-1"
                        type="Icon"
                      ></span
                      >Email is required
                    </div>
                    <div
                      [hidden]="
                        email.valid || email.pristine || !email.errors.pattern
                      "
                      class="boxcolour"
                    >
                      <span
                        _ngcontent-c8=""
                        class="fa fa-exclamation-circle mr-1"
                        type="Icon"
                      ></span
                      >Please enter a valid email
                    </div>
                  </div>
                </div>
                <div class="invalid-feedback posabs">
                  <div
                    class="boxcolour"
                    *ngIf="
                      f.submitted &&
                      email.invalid &&
                      email.errors &&
                      email.errors.required
                    "
                  >
                    <span
                      class="fa fa-exclamation-circle mr-1"
                      type="Icon"
                    ></span
                    >Email is required
                  </div>
                  <div
                    [hidden]="
                      email.valid || email.pristine || !email.errors.pattern
                    "
                    class="boxcolour"
                  >
                    <span
                      _ngcontent-c8=""
                      class="fa fa-exclamation-circle mr-1"
                      type="Icon"
                    ></span
                    >Please enter a valid email
                  </div>
                </div>
                <div class="mt-2" *ngIf="msg">
                  <p class="subscribe">{{ msg }}</p>
                </div>
                <div>
                  <p class="mb-0 mob-text-left">
                    The Honest Gorilla team is constantly serving up fresh
                    content to give you an edge up in life. Join our exclusive
                    mailing list and let’s stay connected.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</section>

<section class="continue-reading">
  <div class="container pb-5">
    <h4 class="text-center mt-2 mb-sm-5">Continue Reading</h4>
    <div id="myUL">
      <div *ngFor="let blog of continueBlogs; let i = index">
        <div class="row mt-4 pt-1 blog-cards" *ngIf="i % 3 == 0">
          <div class="col-md-12 d-flex px-0">
            <div class="col-md-4" *ngIf="i < continueBlogs.length">
              <div class="card mb-2 shadow h-100">
                <img
                  class="card-img-top"
                  src="{{ continueBlogs[i].article_img }}"
                  alt="{{ continueBlogs[i].article_description }}"
                  title="{{ continueBlogs[i].article_title }}"
                  (click)="articleNavigate(i + 1)"
                />
                <div class="card-body">
                  <h5 class="card-title" (click)="articleNavigate(i + 1)">
                    {{ continueBlogs[i].article_header }}
                  </h5>
                  <p class="card-text">
                    {{ continueBlogs[i].article_sub_header }}
                  </p>
                  <a
                    (click)="articleNavigate(i + 1)"
                    class="btn btn-sm readmore"
                    ><span>... Read More</span></a
                  >
                  <div class="tags-group">
                    <p
                      class="tags"
                      *ngFor="let tag of continueBlogs[i].tags"
                      (click)="showSerched(tag)"
                    >
                      {{ tag }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4" *ngIf="i + 1 < continueBlogs.length">
              <div class="card mb-2 shadow h-100">
                <img
                  class="card-img-top"
                  src="{{ continueBlogs[i + 1].article_img }}"
                  alt="{{ continueBlogs[i + 1].article_description }}"
                  title="{{ continueBlogs[i + 1].article_title }}"
                  (click)="articleNavigate(i + 2)"
                />
                <div class="card-body">
                  <h5 class="card-title" (click)="articleNavigate(i + 2)">
                    {{ continueBlogs[i + 1].article_header }}
                  </h5>
                  <p class="card-text">
                    {{ continueBlogs[i + 1].article_sub_header }}
                  </p>
                  <a
                    (click)="articleNavigate(i + 2)"
                    class="btn btn-sm readmore"
                    ><span>... Read More</span></a
                  >
                  <div class="tags-group">
                    <p
                      class="tags"
                      *ngFor="let tag of continueBlogs[i + 1].tags"
                      (click)="showSerched(tag)"
                    >
                      {{ tag }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4" *ngIf="i + 2 < continueBlogs.length">
              <div class="card mb-2 shadow h-100">
                <img
                  class="card-img-top"
                  src="{{ continueBlogs[i + 2].article_img }}"
                  alt="{{ continueBlogs[i + 2].article_description }}"
                  title="{{ continueBlogs[i + 2].article_title }}"
                  (click)="articleNavigate(i + 3)"
                />
                <div class="card-body">
                  <h5 class="card-title" (click)="articleNavigate(i + 3)">
                    {{ continueBlogs[i + 2].article_header }}
                  </h5>
                  <p class="card-text">
                    {{ continueBlogs[i + 2].article_sub_header }}
                  </p>
                  <a
                    (click)="articleNavigate(i + 3)"
                    class="btn btn-sm readmore"
                    ><span>... Read More</span></a
                  >
                  <div class="tags-group">
                    <p
                      class="tags"
                      *ngFor="let tag of continueBlogs[i + 2].tags"
                      (click)="showSerched(tag)"
                    >
                      {{ tag }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--content end-->
<app-blog-footer></app-blog-footer>
